@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

.panelBody {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	background-color: Colors.$col-white;
}

.panelMessage {
	padding: Constants.$val-spacing-s Constants.$val-spacing-m Constants.$val-spacing-l;
	color: Colors.$col-canceledRed;
	font-style: italic;
	background-color: Colors.$col-white;
}

.timeSheetEntry {
	display: flex;
	flex-direction: row;
	padding: Constants.$val-spacing-s;
	background-color: Colors.$col-white;


	.workTypeIcon{
		flex: 0.5;
		color: Colors.$col-canceledRed;
		display: flex;
		align-self: center;
		justify-content: center;
		
		& [class^="icon-"] {
			font-size: Constants.$val-fontSizeXBig;
		}
	}

	.workTypeInfo{
		flex: 4;
		display: flex;
		flex-direction: column;

		.firstRow{
			display: flex;
			flex-direction: row;
			
			.workType {
				font-weight: bold;
			}

			.workOrderCode {
				margin-left: Constants.$val-spacing-s;
			}
			.unassigned {
				margin-left: Constants.$val-spacing-s;
				color: Colors.$col-canceledRed;
				font-size: Constants.$val-fontSizeSmall;
				align-self: center;
			}
		}

		.secondRow{
			display: flex;
			flex-direction: row;

			.startEndTime {
				color: Colors.$col-greyInactive;
				font-size: Constants.$val-fontSizeSmall;
				padding: 0 Constants.$val-spacing-xxs;
			}
		}

		.workOrderCodeSeparator {
			margin-left: Constants.$val-spacing-s;
			border-left: 1px solid Colors.$col-greyFontLight;
			height: auto;
		}
	}

	.workTypeDuration{
		flex: 1;
		font-weight: bold;
		display: flex;
		align-self: center;
		justify-content: center;
	}

	.workTypeEditIcon{
		flex: 0.5;
		display: flex;
		align-self: center;
		justify-content: center;
	}

	.dropdownPart {
		flex: 3;
		color: Colors.$col-darkBlueBorder;
		font-weight: bold;
		align-self: center;
		justify-content: center;
		font-size: Constants.$val-fontSizeBig;
	}

	.deleteIcon {
		flex: 0.5;
		color: Colors.$col-canceledRed;
		font-weight: bold;
		display: flex;
		align-self: center;
		justify-content: center;
		font-size: Constants.$val-fontSizeBig;
		&:hover{
			cursor: pointer;
		}
	}
}

.item-option {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	font-size: Constants.$val-fontSizeRegular;

	&__details {
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-greyFontLight;
		font-weight: normal;
	}
}